import React, {useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Button} from "../../../../../components/Button";
import {ChevronsDown1} from "../../../../../icons/ChevronsDown1";
import {ChevronsDown2} from "../../../../../icons/ChevronsDown2";
import {Icons1} from "../../../../../icons/Icons1";
import {Icons19} from "../../../../../icons/Icons19";
import {NameMenuDarkTrue} from "../../../../../icons/NameMenuDarkTrue";
import {TrailingIcon14} from "../../../../../icons/TrailingIcon14";
import {TrailingIcon19} from "../../../../../icons/TrailingIcon19";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import {FrameCorp} from "../../../../../components/FrameCorp";
import "./style.css";

export const CorporativoLanding = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();
  const scrollRef = useRef(null);

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-card_details-corporativo-mobile${currentParams}`);
  };

  return (
      <div className="contenedor">
        <div className="corporativo-landing" ref={scrollRef}>
          {/* {isFocused && <div className="overlay" onClick={toggleFocus}></div>} */}
          <div className="div-3">
            <div className="overlap-3">
              <header className="header">
                <div className="overlap-group-7">
                  <div className="rectangle-4" />

                  <div className="frame-6">
                    <FrameCorp color={colors.septimo} />
                  </div>

                  <div className="frame-7">
                    <div className="text-wrapper-11">Good morning, Mary</div>

                    <div className="frame-8">
                      <Icons1 className="icon-instance-node-2" color="white" />
                      <NameMenuDarkTrue
                          className="icon-instance-node-2"
                          color="white"
                      />
                    </div>
                  </div>
                </div>
              </header>

              <img className="vector-2" alt="Vector" src="/img/vector-101.svg" />

              <div className="frame-9">
                <div className="accounts">
                  <div className="tarjtetas">
                    <div className="title">Accounts</div>

                    <div className="frame-10">
                      <Icons19 className="icon-instance-node-2" color="white" />
                      <div className="menu-copy">
                        <div className="oval" />

                        <div className="oval-2" />

                        <div className="oval-3" />
                      </div>
                    </div>
                  </div>

                  <div
                      className="account highlighted-button"
                      onClick={handleButtonClick}
                  >
                    <div className="frame-11">
                      <div className="text-wrapper-12">Balance</div>

                      <p className="element-USD">
                        <span className="span">$13,000</span>

                        <span className="text-wrapper-13">.23</span>

                        <span className="text-wrapper-14">&nbsp;</span>

                        <span className="text-wrapper-15">USD</span>
                      </p>
                    </div>

                    <div className="frame-12">
                      <p className="main-account">
                        <span className="span">Main account </span>

                        <span className="text-wrapper-16">| ****2357</span>
                      </p>

                      <Button
                          className="button-instance"
                          divClassName="button-4"
                          leadingIcon={false}
                          size="small"
                          text="Transactions"
                          trailingIcon
                          trailingIcon14StyleOverrideClassName="button-5"
                          trailingIcon14Color={colors.secundario}
                          type="text"
                      />
                    </div>
                  </div>

                  <div className="button-6">
                    <div className="text-wrapper-17">More</div>

                    <TrailingIcon19 className="trailing-icon" />
                  </div>
                </div>

                <div className="botonera">
                  <div className="frame-13">
                    <img
                        className="invoice"
                        alt="Invoice"
                        src="/img/invoice.svg"
                    />

                    <div className="texto-iconos">Pay Bills</div>
                  </div>

                  <div className="frame-14">
                    <div className="overlap-group-wrapper">
                      <div className="overlap-group-8">
                        <div className="ellipse-3" />

                        <img className="star" alt="Star" src="/img/star-1.svg" />

                        <img
                            className="vector-3"
                            alt="Vector"
                            src="/img/vector-2.svg"
                        />
                      </div>
                    </div>

                    <div className="texto-iconos">Goals</div>
                  </div>

                  <div className="frame-13">
                    <img
                        className="btn-icon-contacts"
                        alt="Btn icon contacts"
                        src="/img/btn-icon-contacts-2.svg"
                    />

                    <div className="texto-iconos">Contacts</div>
                  </div>

                  <div className="frame-15">
                    <img className="plus" alt="Plus" src="/img/plus.svg" />

                    <div className="texto-iconos">Hub</div>
                  </div>
                </div>

                <div className="cards">
                  <div className="div-4">
                    <div className="title-2">Cards</div>

                    <div className="frame-16">
                      <Icons19
                          className="icon-instance-node-2"
                          color={colors.secundario}
                      />
                      <div className="menu-copy">
                        <div className="oval-4" />

                        <div className="oval-5" />

                        <div className="oval-6" />
                      </div>
                    </div>
                  </div>

                  <div className="cardss">
                    <div className="gold">
                      <div className="div-4">
                        {/* <img className="shape" alt="Shape" src="/img/shape.svg" /> */}

                        <div className="text-wrapper-21">
                          Credit GOLD ****5849
                        </div>

                        <TrailingIcon19 className="trailing-icon" />
                      </div>
                    </div>

                    {/* <div className="silver">
                    <div className="frame-17">
                      <div className="logo-mastercard">
                        <div className="shapes">
                          <img
                            className="mastercard"
                            alt="Mastercard"
                            src="/img/mastercard.svg"
                          />

                          <div className="overlap-group-9">
                            <img
                              className="middle"
                              alt="Middle"
                              src="/img/middle.svg"
                            />

                            <img className="red" alt="Red" src="/img/red.svg" />

                            <img
                              className="orange"
                              alt="Orange"
                              src="/img/orange.svg"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="text-wrapper-21">
                        Credit SILVER ****2345
                      </div>

                      <ChevronRight
                        chevronRight="/img/trailing-icon-21.png"
                        className="chevron-right-instance"
                      />
                    </div>
                  </div> */}
                  </div>

                  {/* <div className="img-slider-dots">
                  <SliderDots className="slider-dots-instance" status="on" />
                  <SliderDots className="slider-dots-2" status="off" />
                </div> */}
                </div>

                <div className="balances">
                  <div className="div-5">
                    <img
                        className="group-2"
                        alt="Group"
                        src="/img/group-637-2.svg"
                    />

                    <div className="frame-18">
                      <div className="frame-19">
                        <div className="ellipse-4" />

                        <p className="div-6">
                        <span className="span">
                          T. Balance
                          <br />
                        </span>

                          <span className="text-wrapper-22">$13,000</span>
                        </p>
                      </div>

                      <div className="frame-19">
                        <div className="ellipse-5" />

                        <p className="div-6">
                        <span className="span">
                          Debts
                          <br />
                        </span>

                          <span className="text-wrapper-22">$8,000</span>
                        </p>
                      </div>
                    </div>

                    <div className="frame-20">
                      <div className="text-wrapper-23">Total balance | Debts</div>

                      <TrailingIcon14
                          className="trailing-icon"
                          style={{ color: colors.primario }}
                      />
                    </div>
                  </div>

                  <div className="div-5">
                    <div className="frame-21">
                      <div className="frame-22">
                        <div className="text-wrapper-23">
                          Expenses &amp; Incomes
                        </div>

                        <TrailingIcon14
                            className="trailing-icon"
                            style={{ color: colors.primario }}
                        />
                      </div>

                      <div className="chart">
                        <div className="frame-23">
                          <div className="rectangle-5" />

                          <div className="rectangle-6" />
                        </div>

                        <div className="frame-23">
                          <div className="rectangle-7" />

                          <div className="rectangle-8" />
                        </div>
                      </div>

                      <div className="frame-24">
                        <div className="text-wrapper-24">September</div>

                        <div className="frame-25">
                          <div className="expenses-wrapper">
                            <div className="text-wrapper-24">
                              Expenses
                              <br />
                              $2,000
                            </div>
                          </div>

                          <div className="incomes-wrapper">
                            <div className="text-wrapper-24">
                              Incomes
                              <br />
                              $3,200
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="banners">
                  <div className="overlap-wrapper">
                    <div className="overlap-4">
                      <img
                          className="image-2"
                          alt="Image"
                          src="/img/image-62026.png"
                      />

                      <div className="frame-26">
                        <img
                            className="image-3"
                            alt="Image"
                            src="/img/image-62032.png"
                        />

                        <div className="group-3">
                          <div className="overlap-group-10">
                            <p className="in-all-TACOS">
                            <span className="text-wrapper-25">
                              in all
                              <br />
                            </span>

                              <span className="text-wrapper-26">TACOS</span>
                            </p>

                            <p className="element-OFF">
                              <span className="text-wrapper-27">40</span>

                              <span className="text-wrapper-28">%OFF</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <img
                      className="image-4"
                      alt="Image"
                      src="/img/image-62014.png"
                  />

                  <img
                      className="image-5"
                      alt="Image"
                      src="/img/image-62011.png"
                  />

                  <img
                      className="image-4"
                      alt="Image"
                      src="/img/image-62017.png"
                  />
                </div>
              </div>

              {/* <div className="content-wrapper">
              <div className="content-3">
                <div className="text-wrapper-29">9:50</div>

                <img className="icons-2" alt="Icons" src="/img/icons.svg" />
              </div>
            </div> */}
            </div>

            <div className="menu">
              <div className="single-tab">
                <div className="icon-and-text">
                  <ChevronsDown1 className="icon-instance-node-2" />
                  <div className="text-footer-botones">Send</div>
                </div>
              </div>

              <div className="single-tab">
                <div className="icon-and-text-2">
                  <ChevronsDown2 className="icon-instance-node-2" />
                  <div className="text-footer-botones">Receive</div>
                </div>
              </div>

              <div className="single-tab">
                <div className="icon-and-text-3">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={25}
                      height={25}
                      viewBox="0 0 42.000000 40.000000"
                      preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                        transform="translate(0.000000,40.000000) scale(0.100000,-0.100000)"
                        fill={colors.primario}
                        stroke={colors.primario}
                    >
                      <path d="M10 330 c0 -37 4 -50 13 -47 7 2 12 21 12 47 0 26 -5 45 -12 48 -9 2 -13 -11 -13 -48z" />
                      <path d="M82 298 l3 -83 53 -3 c42 -2 52 0 52 12 0 12 -11 16 -40 16 -33 0 -40 3 -40 19 0 16 8 20 38 23 37 3 37 3 40 51 l3 47 -56 0 -56 0 3 -82z m78 32 c0 -15 -7 -20 -25 -20 -18 0 -25 5 -25 20 0 15 7 20 25 20 18 0 25 -5 25 -20z" />
                      <path d="M232 298 l3 -83 88 -3 87 -3 0 86 0 85 -90 0 -91 0 3 -82z m148 -3 l0 -55 -60 0 -60 0 0 55 0 55 60 0 60 0 0 -55z" />
                      <path d="M310 294 c0 -17 22 -14 28 4 2 7 -3 12 -12 12 -9 0 -16 -7 -16 -16z" />
                      <path d="M10 225 c0 -9 5 -15 11 -13 14 5 14 21 0 26 -6 2 -11 -4 -11 -13z" />
                      <path d="M10 85 l0 -85 90 0 91 0 -3 83 -3 82 -87 3 -88 3 0 -86z m148 -2 l3 -53 -60 0 -61 0 0 55 0 56 58 -3 57 -3 3 -52z" />
                      <path d="M87 93 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z" />
                      <path d="M230 121 l0 -51 90 0 90 0 0 51 c0 57 -23 66 -28 11 -2 -24 -8 -32 -22 -32 -14 0 -20 9 -22 33 -3 31 -4 32 -55 35 l-53 3 0 -50z m80 -1 c0 -15 -7 -20 -25 -20 -18 0 -25 5 -25 20 0 15 7 20 25 20 18 0 25 -5 25 -20z" />
                      <path d="M230 15 c0 -12 13 -15 55 -15 42 0 55 3 55 15 0 12 -13 15 -55 15 -42 0 -55 -3 -55 -15z" />
                      <path d="M387 24 c-8 -8 1 -24 14 -24 5 0 9 7 9 15 0 15 -12 20 -23 9z" />
                    </g>
                  </svg>
                  <div className="text-footer-botones">QR</div>
                </div>
              </div>

              <div className="single-tab">
                <div className="icon-and-text-4">
                  <svg
                      width={25}
                      height={25}
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.25 4C7.563 4 3.75 7.813 3.75 12.5C3.75 17.187 7.563 21 12.25 21C16.937 21 20.75 17.187 20.75 12.5C20.75 7.813 16.937 4 12.25 4ZM12.25 22.5C6.736 22.5 2.25 18.014 2.25 12.5C2.25 6.986 6.736 2.5 12.25 2.5C17.764 2.5 22.25 6.986 22.25 12.5C22.25 18.014 17.764 22.5 12.25 22.5Z"
                        fill={colors.primario}
                    />
                    <path
                        d="M12.25 3.5C7.28686 3.5 3.25 7.53686 3.25 12.5H4.25C4.25 8.08914 7.83914 4.5 12.25 4.5V3.5ZM3.25 12.5C3.25 17.4631 7.28686 21.5 12.25 21.5V20.5C7.83914 20.5 4.25 16.9109 4.25 12.5H3.25ZM12.25 21.5C17.2131 21.5 21.25 17.4631 21.25 12.5H20.25C20.25 16.9109 16.6609 20.5 12.25 20.5V21.5ZM21.25 12.5C21.25 7.53686 17.2131 3.5 12.25 3.5V4.5C16.6609 4.5 20.25 8.08914 20.25 12.5H21.25ZM12.25 22C7.01214 22 2.75 17.7379 2.75 12.5H1.75C1.75 18.2901 6.45986 23 12.25 23V22ZM2.75 12.5C2.75 7.26214 7.01214 3 12.25 3V2C6.45986 2 1.75 6.70986 1.75 12.5H2.75ZM12.25 3C17.4879 3 21.75 7.26214 21.75 12.5H22.75C22.75 6.70986 18.0401 2 12.25 2V3ZM21.75 12.5C21.75 17.7379 17.4879 22 12.25 22V23C18.0401 23 22.75 18.2901 22.75 12.5H21.75Z"
                        fill={colors.primario}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.6811 16.1925C15.5501 16.1925 15.4181 16.1585 15.2971 16.0875L11.5271 13.8385C11.3011 13.7025 11.1611 13.4575 11.1611 13.1935V8.34546C11.1611 7.93146 11.4971 7.59546 11.9111 7.59546C12.3261 7.59546 12.6611 7.93146 12.6611 8.34546V12.7675L16.0661 14.7975C16.4211 15.0105 16.5381 15.4705 16.3261 15.8265C16.1851 16.0615 15.9361 16.1925 15.6811 16.1925Z"
                        fill={colors.primario}
                    />
                    <path
                        d="M15.6811 16.1925C15.5501 16.1925 15.4181 16.1585 15.2971 16.0875L11.5271 13.8385C11.3011 13.7025 11.1611 13.4575 11.1611 13.1935V8.34546C11.1611 7.93146 11.4971 7.59546 11.9111 7.59546C12.3261 7.59546 12.6611 7.93146 12.6611 8.34546V12.7675L16.0661 14.7975C16.4211 15.0105 16.5381 15.4705 16.3261 15.8265C16.1851 16.0615 15.9361 16.1925 15.6811 16.1925"
                        stroke={colors.primario}
                    />
                  </svg>
                  <div className="text-footer-botones">Transactions</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
